import { IconButton, Stack, TableCell, TableRow, Typography } from '@mui/material'
import { MoreVertical20Regular } from '@/components/Icon'
import shared from '@/components/Settings/settingsShared.module.scss'
import UsersTableStatusChip from './UsersTableStatusChip'

export default function UsersTableRow({ row, isLast, openMenu, menuUserId, onOpenMenu }) {
  return (
    <TableRow
      hover
      className={`${shared.tableBodyRow}${isLast ? ` ${shared.tableBodyRowLast}` : ''}`}
    >
      <TableCell className={shared.tdCell}>
        <Stack spacing={0.25}>
          <Typography variant="body2" color="text.primary" className={shared.userName}>{row.name}</Typography>
          <Typography variant="caption" color="text.secondary" className={shared.userEmail}>{row.email}</Typography>
        </Stack>
      </TableCell>
      <TableCell className={shared.tdCell}>
        <Typography variant="body2" color="text.primary">{row.role}</Typography>
      </TableCell>
      <TableCell className={shared.tdCell}>
        <Typography variant="body2" color="text.secondary">{row.seat}</Typography>
      </TableCell>
      <TableCell className={shared.tdCell}>
        <UsersTableStatusChip status={row.status} />
      </TableCell>
      <TableCell className={shared.tdCell}>
        <Typography variant="body2" color="text.secondary">{row.extra}</Typography>
      </TableCell>
      <TableCell align="right" className={shared.tdCellActions}>
        <IconButton
          size="small"
          aria-label={`Actions for ${row.name}`}
          aria-haspopup="true"
          aria-expanded={openMenu && menuUserId === row.id}
          onClick={(e) => onOpenMenu(e, row.id)}
        >
          <MoreVertical20Regular />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}
